import imagesUrls from "../../Constants/imagesUrls";
export default function Loader() {
  return (
    <div className="py-5">
      <img src={imagesUrls.fyers_loader_gif} width={140} alt="Loading!" />
    </div>
  );
}
